"use client";

import type { ReactNode } from "react";

/**
 * Layout wrapper for side-by-side content views.
 * Used by VoiceChangerV2, VoiceIsolatorV2, etc. for input/result states.
 */
export function ViewLayout({ children, footer }: { children: ReactNode; footer: ReactNode }) {
  return (
    <div className='tw-flex tw-size-full tw-flex-1 tw-flex-col'>
      <div className='tw-flex tw-flex-1 tw-min-h-0'>{children}</div>
      <div className='tw-flex tw-flex-col tw-justify-end'>{footer}</div>
    </div>
  );
}
